module.exports = __webpack_public_path__ + "img/0-02-0a-8c1298705fb411b4187bf6a17cd72f51e672861ea5726267242562fc2f434b90_cc6bad62.29b07e08.jpg";